import type { SystemDiskSizeBlockOptions, SystemDiskSizePaths } from './types';

/** 按 pathPrefix + options 生成 form 路径 */
export function resolveSystemDiskSizePaths(prefix: string, options?: SystemDiskSizeBlockOptions): SystemDiskSizePaths {
  const segment = options?.fieldSegment ?? 'systemDiskSize';
  /** 计价厂商设备默认挂顶层，与历史 CI systemDiskPricing 一致 */
  const pricing = options?.pricingSegment ?? 'systemDiskPricing';

  return {
    size: prefix ? `${prefix}.${segment}` : segment,
    pricing,
  };
}
